import { FC } from "react";
import { useParams } from "react-router-dom";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Drawer } from "@mui/material";

import { SATOSLink } from "@/components/Application/SATOSLink";
import { Translate } from "@/components/Application/Translate";
import { ActiveArchiveProcedures } from "@/components/Archive/ActiveArchiveProcedures";

import { RouteParams } from "@/service/Utilities";

type IHistoryDrawer = {
	historyOpen: boolean;
	toggleHistory: (open: boolean) => void;
};

export const HistoryDrawer: FC<IHistoryDrawer> = ({
	historyOpen,
	toggleHistory,
}) => {
	const { id } = useParams<RouteParams>();

	return (
		<Drawer
			anchor="right"
			open={historyOpen}
			onClose={() => toggleHistory(false)}
			elevation={40}
			PaperProps={{
				sx: {
					width: 600,
					padding: 5,
					backgroundColor: "#ffffff73",
					boxShadow: "0 8px 32px 0 rgba( 0, 0, 0, 0.37 )",
					backdropFilter: "blur(10.5px)",
				},
			}}
		>
			<SATOSLink to={"ArchiveProcedure"} params={[parseInt(id)]}>
				<Translate String="Procedure.History.SeeFull">
					See full history
				</Translate>
				<OpenInNewIcon sx={{ width: "20px", height: "20px" }} />
			</SATOSLink>
			<ActiveArchiveProcedures
				expanded={true}
				startDate={undefined}
				endDate={undefined}
				selectedUser={1}
			/>
		</Drawer>
	);
};